var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DAD51ACA-7A12-476E-8A4E-D819D5B62C99") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000360902256 0.383819549 79.616 0.383819549 79.616 80 0.000360902256 80"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hospitalization-desktop",
    transform: "translate(-223.000000, -2136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(223.000000, 2136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.616,40.1919398 C79.616,62.1775038 61.7928421,80.0000602 39.8072782,80.0000602 C17.8229173,80.0000602 0.000360902256,62.1775038 0.000360902256,40.1919398 C0.000360902256,18.2063759 17.8229173,0.383819549 39.8072782,0.383819549 C61.7928421,0.383819549 79.616,18.2063759 79.616,40.1919398",
    id: "Fill-1",
    fill: "#3A913F",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.4997382,37.5418886 C39.4997382,37.5418886 40.6465982,34.8316633 43.2629657,35.008271 C44.6561352,35.1017692 45.9085564,35.9420307 46.5502732,37.2125061 C46.9653614,38.0319902 47.2063034,39.1533574 46.7631848,40.554608 C46.6021592,41.0612093 46.3671812,41.5378668 46.0719676,41.9735805 C45.9574605,42.1422439 45.8363931,42.3054074 45.7051871,42.4618489 C45.1290733,43.1481133 44.0340994,44.2511475 42.9373362,45.195907 C42.9373362,45.195907 40.1509972,47.4850849 39.4997382,49 C38.8496719,47.4850849 36.0621401,45.195907 36.0621401,45.195907 C34.9659734,44.2511475 33.8709994,43.1481133 33.2942893,42.4618489 C33.1630832,42.3054074 33.0414195,42.1422439 32.9281052,41.9735805 C32.6328916,41.5378668 32.3967207,41.0612093 32.2362915,40.554608 C31.7943658,39.1533574 32.034115,38.0319902 32.4492031,37.2125061 C33.0909199,35.9420307 34.3433411,35.1017692 35.737107,35.008271 C38.354071,34.8316633 39.4997382,37.5418886 39.4997382,37.5418886",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4997382,37.5418886 C39.4997382,37.5418886 40.6465982,34.8316633 43.2629657,35.008271 C44.6561352,35.1017692 45.9085564,35.9420307 46.5502732,37.2125061 C46.9653614,38.0319902 47.2063034,39.1533574 46.7631848,40.554608 C46.6021592,41.0612093 46.3671812,41.5378668 46.0719676,41.9735805 C45.9574605,42.1422439 45.8363931,42.3054074 45.7051871,42.4618489 C45.1290733,43.1481133 44.0340994,44.2511475 42.9373362,45.195907 C42.9373362,45.195907 40.1509972,47.4850849 39.4997382,49 C38.8496719,47.4850849 36.0621401,45.195907 36.0621401,45.195907 C34.9659734,44.2511475 33.8709994,43.1481133 33.2942893,42.4618489 C33.1630832,42.3054074 33.0414195,42.1422439 32.9281052,41.9735805 C32.6328916,41.5378668 32.3967207,41.0612093 32.2362915,40.554608 C31.7943658,39.1533574 32.034115,38.0319902 32.4492031,37.2125061 C33.0909199,35.9420307 34.3433411,35.1017692 35.737107,35.008271 C38.354071,34.8316633 39.4997382,37.5418886 39.4997382,37.5418886 Z",
    id: "Stroke-6",
    stroke: "#FFFFFF",
    strokeWidth: 1.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,40.5 C51,46.8511119 45.8518432,52 39.4997012,52 C33.1493518,52 28,46.8511119 28,40.5 C28,34.1488881 33.1493518,29 39.4997012,29 C45.8518432,29 51,34.1488881 51,40.5 Z",
    id: "Stroke-8",
    stroke: "#FFFFFF",
    strokeWidth: 1.844,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,25.8981426 C44.6982436,23.8268424 44.4471638,20.3379269 44.4471638,17 L40.0071984,17 L35.5678088,17 C35.5678088,20.3930497 35.3086669,23.9155183 35,26",
    id: "Stroke-10",
    stroke: "#FFFFFF",
    strokeWidth: 1.844,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,25.5 L45,25.5",
    id: "Stroke-12",
    stroke: "#FFFFFF",
    strokeWidth: 1.844,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,26 L45.8354122,26 C46.4797688,26 47,26.5627876 47,27.2583826 L47,29",
    id: "Stroke-14",
    stroke: "#FFFFFF",
    strokeWidth: 1.844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,26 L34.1642336,26 C33.5212895,26 33,26.5627876 33,27.2583826 L33,29",
    id: "Stroke-16",
    stroke: "#FFFFFF",
    strokeWidth: 1.844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,55.1018506 C44.6982436,57.1730129 44.4471638,60.6616962 44.4471638,64 L40.0071984,64 L35.5678088,64 C35.5678088,60.606577 35.3086669,57.0849421 35,55",
    id: "Stroke-18",
    stroke: "#FFFFFF",
    strokeWidth: 1.844,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,55.5 L45,55.5",
    id: "Stroke-20",
    stroke: "#FFFFFF",
    strokeWidth: 1.844,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,55 L45.8354122,55 C46.4797688,55 47,54.4377466 47,53.7413415 L47,52",
    id: "Stroke-22",
    stroke: "#FFFFFF",
    strokeWidth: 1.844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,55 L34.1642336,55 C33.5212895,55 33,54.4377466 33,53.7413415 L33,52",
    id: "Stroke-24",
    stroke: "#FFFFFF",
    strokeWidth: 1.844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,43 L53.9895338,43 C54.547098,43 55,42.5220244 55,41.9315839 L55,39.0684161 C55,38.4779756 54.547098,38 53.9895338,38 L53,38",
    id: "Stroke-26",
    stroke: "#FFFFFF",
    strokeWidth: 1.844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5684831,46 C39.5684831,46 39.371134,45.8649299 38.9764359,45.5935155 C38.5817378,45.3233753 38.2765832,44.938553 38.0592047,44.4422342 C37.8424153,43.9433668 37.7346097,43.3674076 37.7346097,42.7137194 L37.7346097,40.2926518 C37.7346097,39.6376894 37.8424153,39.061093 38.0592047,38.5647742 C38.2765832,38.0671811 38.5817378,37.6817216 38.9764359,37.4096701 C39.371134,37.1357072 39.8276878,37 40.3472754,37 C40.7885125,37 41.1944035,37.0974798 41.5649485,37.2937137 C41.9349043,37.4905847 42.2441826,37.7683704 42.495729,38.1283449 C42.7460972,38.4876823 42.9145803,38.9037236 43,39.3764689 L41.7893962,39.3764689 C41.7104566,39.1381849 41.5979381,38.9279343 41.45243,38.7457171 C41.3063328,38.5647742 41.1372607,38.4233329 40.9446244,38.3245788 C40.7525773,38.2258247 40.553461,38.1761291 40.3472754,38.1761291 C40.0562592,38.1761291 39.7994109,38.263415 39.5767305,38.4398981 C39.3540501,38.615744 39.1820324,38.8635849 39.0606775,39.1827835 C38.9393225,39.5026193 38.878056,39.8727878 38.878056,40.2926518 L38.878056,42.7137194 C38.878056,43.1335835 38.9393225,43.5031148 39.0606775,43.8229506 C39.1820324,44.1421492 39.3540501,44.389353 39.5767305,44.5626504 C39.7994109,44.7372221 40.0562592,44.8232338 40.3472754,44.8232338 C40.553461,44.8232338 40.7513991,44.7792723 40.942268,44.6894379 C41.1325479,44.6021521 41.30162,44.4740903 41.4494845,44.311624 C41.5967599,44.1478833 41.7104566,43.9580207 41.7893962,43.7439473 L43,43.7439473 C42.9104566,44.1924819 42.7407953,44.5881354 42.4892489,44.9296333 C42.2394698,45.2711312 41.9290133,45.5355373 41.5584683,45.7215772 C41.1885125,45.90698 40.7849779,46 40.3472754,46 L39.5684831,46 Z M37,42.7137194 L40.8686303,42.7137194 L40.8686303,41.8644344 L37,41.8644344 L37,42.7137194 Z M37,41.1483081 L40.8686303,41.1483081 L40.8686303,40.2990231 L37,40.2990231 L37,41.1483081 Z",
    id: "Fill-28",
    fill: "#3A913F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.744de75c8ae08944429f74bb4fb517a5.svg";
export { ForwardRef as ReactComponent };